import { apiClient, retryRequest } from './httpClient';

// Generic POST request wrapper with retry functionality
export async function postGeneral(endpoint, data = null, options = {}) {
    const requestConfig = {
        url: endpoint,
        method: 'POST',
        ...options
    };

    if (data) {
        requestConfig.data = data;
    }

    try {
        const response = await retryRequest(() => apiClient(requestConfig));
        return response.data;
    } catch (error) {
        const err = new Error(error.data || 'POST request failed');
        err.status = error.status || 500;
        err.endpoint = endpoint;
        err.method = 'POST';
        throw err;
    }
}

export async function getGeneralById(endpoint, id, options = {}) {
    const requestConfig = {
        url: `${endpoint}/${id}`,
        method: 'GET',
        ...options
    };

    try {
        const response = await retryRequest(() => apiClient(requestConfig));
        return response.data;
    } catch (error) {
        const err = new Error(error.data || 'GET request failed');
        err.status = error.status || 500;
        err.endpoint = endpoint;
        err.method = 'GET';
        throw err;
    }
}

export async function generalById(endpoint, id, options = {}) {
    const requestConfig = {
        url: `${endpoint}/${id}/edit`,
        method: 'GET',
        ...options
    };

    try {
        const response = await retryRequest(() => apiClient(requestConfig));
        return response.data;
    } catch (error) {
        const err = new Error(error.data || 'GET request failed');
        err.status = error.status || 500;
        err.endpoint = endpoint;
        err.method = 'GET';
        throw err;
    }
}

// Get general list with optional params (for sorting, pagination, etc.)
export async function getTaskList(endpoint, method = "GET", data = null, options = {}) {
    const requestConfig = {
        url: endpoint,
        method: method.toUpperCase(),
        ...options
    };

    if (data) {
        if (method.toUpperCase() === 'GET') {
            requestConfig.params = data;
        } else {
            requestConfig.data = data;
        }
    }

    try {
        const response = await retryRequest(() => apiClient(requestConfig));
        return response.data;
    } catch (error) {
        const apiError = new Error(error.data || 'API request failed');
        apiError.status = error.status || 500;
        apiError.endpoint = endpoint;
        apiError.method = method;
        throw apiError;
    }
}

export async function putGeneral(endpoint, data = null, options = {}) {
    const requestConfig = {
        url: endpoint,
        method: 'PUT',
        ...options
    };

    if (data) {
        requestConfig.data = data;
    }

    try {
        const response = await retryRequest(() => apiClient(requestConfig));
        return response.data;
    } catch (error) {
        const err = new Error(error.data || 'PUT request failed');
        err.status = error.status || 500;
        err.endpoint = endpoint;
        err.method = 'PUT';
        throw err;
    }
}


export async function changeStatus(endpoint, data = null, options = {}) {
    const requestConfig = {
        url: `${endpoint}/change-status`,
        method: 'PUT',
        ...options
    };

    if (data) {
        requestConfig.data = data;
    }

    try {
        const response = await retryRequest(() => apiClient(requestConfig));
        return response.data;
    } catch (error) {
        const err = new Error(error.data || 'PUT request failed');
        err.status = error.status || 500;
        err.endpoint = endpoint;
        err.method = 'PUT';
        throw err;
    }
}
